export const selectCurrentCase = (state) => state.currentCase.currentCase.case;
export const selectCurrentCaseLoading = (state) => state.currentCase.loading

export const selectCurrentCaseId = (state) => state.currentCase.currentCase.case?.caseId;
export const selectCurrentClickToCall = (state)=> state.currentCase.currentCase.case.phoneNumber;
export const selectCurrentCaseCloseDate = (state) => state.currentCase.currentCase.closeDate;
export const selectCurrentCaseCreationDate = (state) => state.currentCase.currentCase.case.creationDate;

export const selectCurrentCasePreviousTaxonomy = (state)=> state.currentCase.currentCase.casePreviousTaxonomy;
export const selectCurrentCaseCalls = (state)=> state.currentCase?.currentCase?.case?.calls;
export const selectCurrentCaseEmails = (state)=> state.currentCase?.currentCase?.case?.emails;
